/**
 * Format: Collection
 * -----------------------------------------------------------------------------
 * Formats Shopify storefront API collection responses.
 *
 */
import { formatProduct } from '~/format/format-product';
import { decodeApiId, transformEdges } from '~/helpers/graphql';

/**
 * Format collection.
 * - https://shopify.dev/docs/api/storefront/2024-01/objects/Collection
 * @param {Object} response - Collection response.
 * @returns {Object}
 */
export function formatCollection(response) {
  const collection = response.collection;

  const formattedCollection = {
    handle: collection.handle,
    id: decodeApiId(collection.id),
    pageInfo: {
      ...collection.products?.pageInfo,
      currentPage: 1,
    },
    url: `//${location.host}${cnvs.routes.normalisedRoot}collections/${collection.handle}`,
  };

  /**
   * Format products.
   */
  formattedCollection.products = transformEdges(collection.products).map(
    (product) => {
      return formatProduct(product, { collection: formattedCollection });
    },
  );

  return formattedCollection;
}
